module.exports = __webpack_public_path__ + "static/placemilo-min-8d4d83c4c84239c12ea51b2ef0dda5cd.png";